import { useEffect, useState } from 'react';

const isCampfireHour = () => {
  const h = new Date().getHours();
  return h >= 22 || h < 5;
};

/**
 * Adds/removes the `campfire-mode` class on <html> when local time is between
 * 10pm and 5am. CSS overrides accent colors and adds a subtle warm glow.
 * Re-checks every 5 minutes so long sessions correctly transition in/out.
 */
export const useCampfireMode = () => {
  const [active, setActive] = useState(isCampfireHour());

  useEffect(() => {
    const apply = () => {
      const on = isCampfireHour();
      setActive(on);
      const root = document.documentElement;
      if (on) root.classList.add('campfire-mode');
      else root.classList.remove('campfire-mode');
    };
    apply();
    const t = setInterval(apply, 5 * 60 * 1000);
    return () => clearInterval(t);
  }, []);

  return active;
};
